module.exports = __webpack_public_path__ + "static/media/message-list-eye.8b25daed.svg";